import React from "react";
import Field from "./components/signup/Field";
import SignupFeedback from "./components/signup/SignupFeedback";
import { useSignup } from "./components/signup/useSignup";

function SignupFields({ form, setField }) {
  return (
    <>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field
          label="First Name"
          value={form.name}
          onChange={setField("name")}
          placeholder="Imo"
          testId="signup-name-input"
        />
        <Field
          label="Email *"
          type="email"
          required
          value={form.email}
          onChange={setField("email")}
          placeholder="you@thenewfield.org"
          testId="signup-email-input"
        />
      </div>
      <Field
        label="Why are you joining? (optional)"
        multiline
        rows={3}
        value={form.why}
        onChange={setField("why")}
        placeholder="I want to be the hundredth monkey because…"
        testId="signup-why-input"
      />
    </>
  );
}

export default function SignupForm() {
  const { form, status, message, setField, handleSubmit } = useSignup();

  return (
    <form onSubmit={handleSubmit} className="grid gap-4" data-testid="signup-form">
      <SignupFields form={form} setField={setField} />
      <div className="flex flex-wrap items-center gap-4 pt-2">
        <button
          type="submit"
          disabled={status === "submitting"}
          className="btn-brutal"
          data-testid="signup-submit-button"
        >
          {status === "submitting" ? "Sending…" : "Add Me To The Field"}
        </button>
        <p className="text-sm opacity-70 font-body italic">
          No spam. No surveillance. Pass it on.
        </p>
      </div>
      <SignupFeedback status={status} message={message} />
    </form>
  );
}
